import type { VoidFunctionComponent } from 'react';

import FilterCard from '../../../../../../../../generic/Filter/FilterCard';
import type { SelectOption } from '../../../../../../../../../types';

type Props = {
  isLoading: boolean;
  labelOptions: SelectOption[];
  selectedLabelOptions: SelectOption[];
  handleLabelsChange: (selected: SelectOption[]) => void;
};

const ProjectLabelsFilter: VoidFunctionComponent<Props> = ({
  isLoading,
  labelOptions,
  selectedLabelOptions,
  handleLabelsChange,
}) => {
  return (
    <FilterCard.MultiSelect
      label="Labels"
      placeholder={isLoading ? 'Loading' : 'Select labels...'}
      options={labelOptions}
      values={selectedLabelOptions}
      onChange={handleLabelsChange}
    />
  );
};

export default ProjectLabelsFilter;
